import React from 'react';
import EmailForm from './EmailForm';
import DashboardHeader from './DashboardHeader';
import Footer from './Footer';
import './Dashboard.css';

const EmailFormPage: React.FC = () => {
  return (
    <div className="dashboard">
      <DashboardHeader title="Send Email" showNav={false} showEmailButton={false} />

      <div className="dashboard-content">
        <div className="email-section">
          <EmailForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EmailFormPage;
